import type { ContentfulArticleSearchResponse } from 'autogen/swagger/all';
import type { FilterOptionType } from 'components/pages/ArticleUniverse/shared/types';

function mapItemToFilterOptions(
    items: ContentfulArticleSearchResponse['topics'] | ContentfulArticleSearchResponse['sections']
): FilterOptionType[] {
    const result: FilterOptionType[] = [];

    items.forEach((item) => {
        const { entryId, publicName, queryParameterName } = item;
        result.push({
            entryId,
            publicName,
            queryParameterName
        });
    });

    return result;
}

export { mapItemToFilterOptions };
